import React, { Component } from "react";
import { push } from "connected-react-router";
import { Helmet } from "react-helmet";
import { connect } from "react-redux";
import { Table } from "components";
import { setBreadcrumb, setLoader, setTitle } from "store/actions";
import { API, Endpoints } from "utils/api";
import { notification } from "antd";
import Strings from "utils/strings";
import { DateTime } from "luxon";

class WorkshopInterventions extends Component<any, any> {
	constructor(props: any) {
		super(props);

		this.state = {
			interventions: []
		};
	}

	componentDidMount() {
		const { dispatch } = this.props;

		dispatch(setTitle(""));
		dispatch(setBreadcrumb(null));

		this.getData();
	}

	async getData() {
		const { dispatch } = this.props;

		dispatch(setLoader(true));

		try {
			const response = await API.get({
				url: Endpoints.uriWorkshopInterventions()
			});

			if (response.ok) {
				this.setState({ interventions: response.data?.results?.intervention || [] });
			}
		} catch (err) {
			console.log("API Error", err);
			notification.error({
				message: Strings.serverErrors.title,
				description: (err as string) || Strings.serverErrors.wentWrong,
				placement: "bottomRight",
				duration: 5
			});
		}

		dispatch(setLoader(false));
	}

	async removeIntervention(id: string) {
		const { dispatch } = this.props;

		dispatch(setLoader(true));

		try {
			const response = await API.delete({
				url: Endpoints.uriWorkshopInterventions(id)
			});

			if (response.ok) {
				this.setState({ interventions: response.data?.results?.intervention || [] });

				notification.success({
					message: Strings.workshop.intervention,
					description: response.data.message || "",
					placement: "bottomRight",
					duration: 5
				});
			} else {
				notification.error({
					message: Strings.serverErrors.title,
					description: response?.data?.message || Strings.serverErrors.wentWrong,
					placement: "bottomRight",
					duration: 5
				});
			}
		} catch (err) {
			notification.error({
				message: Strings.serverErrors.title,
				description: (err as string) || Strings.serverErrors.wentWrong,
				placement: "bottomRight",
				duration: 5
			});
		}

		dispatch(setLoader(false));
	}

	render() {
		const { interventions = [] } = this.state;
		const { dispatch } = this.props;

		return (
			<React.Fragment>
				<Helmet>
					<title>{Strings.workshop.interventions}</title>
					<meta name="description" content="Description of Workshop Interventions" />
				</Helmet>
				<Table
					title={{
						icon: "tools",
						title: Strings.workshop.interventions
					}}
					data={interventions}
					columns={[
						{
							Header: Strings.workshop.date,
							id: "date",
							accessor: (row: any) =>
								row.date && DateTime.fromISO(row.date).toFormat("dd/MM/yyyy")
						},
						{
							Header: Strings.workshop.vehicle,
							id: "vehicle",
							accessor: (row: any) =>
								row.vehicle?.licensePlate || row.vehicle?.name || "-"
						},
						{
							Header: Strings.workshop.items,
							id: "items",
							accessor: (row: any) => (row.items?.length || 0) + " " + Strings.workshop.items
						},
						{
							Header: Strings.workshop.total,
							id: "total",
							align: "right",
							accessor: (row: any) => (row.total && `${row.total.toFixed(2)} €`) || "-"
						}
					]}
					filterable
					isSinglePage
					fullPage
					paginated={false}
					add={{
						onClick: () => dispatch(push("/workshop/interventions/new"))
					}}
					actions={{
						edit: (original: any) => ({
							onClick: () => dispatch(push(`/workshop/interventions/${original._id}`))
						}),
						remove: (original: any) => ({
							onClick: () => this.removeIntervention(original._id)
						})
					}}
				/>
			</React.Fragment>
		);
	}
}

const mapStateToProps = (state: any) => ({
	language: state.language
});

export default connect(mapStateToProps)(WorkshopInterventions);

